import styled from '@emotion/styled';
import { InfoCircleFilled } from '@ant-design/icons';

import { Alert } from 'antd';

export const TipsAlert = styled(Alert)`
  background-color: ${props => props.theme.color.secondary};
  border: none;
  border-radius: 8px 0 0 8px;
  box-shadow: 0 3px 8px ${props => props.theme.color.primary}33;
  margin-left: ${props => props.theme.spacing.xxl};
  padding: ${props => props.theme.spacing.md} !important;
  padding-right: ${props => props.theme.spacing.regular} !important;
  ${props => props.isSticky && 'position: fixed'};
  width: auto;
`;

export const Title = styled.span`
  color: ${props => props.theme.color.primary};
  font-weight: ${props => props.theme.fontWeight.bold};
  font-size: 24px;
`;

export const TipsIcon = styled(InfoCircleFilled)`
  color: ${props => props.theme.color.primary};
  margin-right: ${props => props.theme.spacing.xs};
`;

export const Desc = styled.span`
  color: ${props => props.theme.color.primary};
  font-size: 16px;
`;
